import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/chi/cdf';
import __var_2__ from '@stdlib/stats/base/dists/chi/ctor';
import __var_3__ from '@stdlib/stats/base/dists/chi/entropy';
import __var_4__ from '@stdlib/stats/base/dists/chi/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/chi/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/chi/mean';
import __var_7__ from '@stdlib/stats/base/dists/chi/mode';
import __var_8__ from '@stdlib/stats/base/dists/chi/pdf';
import __var_9__ from '@stdlib/stats/base/dists/chi/quantile';
import __var_10__ from '@stdlib/stats/base/dists/chi/skewness';
import __var_11__ from '@stdlib/stats/base/dists/chi/stdev';
import __var_12__ from '@stdlib/stats/base/dists/chi/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace chi
*/
var chi = {};

/**
* @name cdf
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/cdf}
*/
setReadOnly( chi, 'cdf', __var_1__);

/**
* @name Chi
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/ctor}
*/
setReadOnly( chi, 'Chi', __var_2__);

/**
* @name entropy
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/entropy}
*/
setReadOnly( chi, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/kurtosis}
*/
setReadOnly( chi, 'kurtosis', __var_4__);

/**
* @name logpdf
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/logpdf}
*/
setReadOnly( chi, 'logpdf', __var_5__);

/**
* @name mean
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/mean}
*/
setReadOnly( chi, 'mean', __var_6__);

/**
* @name mode
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/mode}
*/
setReadOnly( chi, 'mode', __var_7__);

/**
* @name pdf
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/pdf}
*/
setReadOnly( chi, 'pdf', __var_8__);

/**
* @name quantile
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/quantile}
*/
setReadOnly( chi, 'quantile', __var_9__);

/**
* @name skewness
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/skewness}
*/
setReadOnly( chi, 'skewness', __var_10__);

/**
* @name stdev
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/stdev}
*/
setReadOnly( chi, 'stdev', __var_11__);

/**
* @name variance
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/variance}
*/
setReadOnly( chi, 'variance', __var_12__);


// EXPORTS //
export default chi;

export { __var_1__ as cdf, __var_2__ as Chi, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as mode, __var_8__ as pdf, __var_9__ as quantile, __var_10__ as skewness, __var_11__ as stdev, __var_12__ as variance};